import { WHY, IMAGES } from "@/data/content";
import { SectionHeading } from "./ui";
import { Reveal } from "./Reveal";

export default function WhyUsSection() {
  return (
    <section id="perche-noi" className="relative bg-brand-ivory py-20 lg:py-32 grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <SectionHeading eyebrow={WHY.eyebrow} title={WHY.title} />
            <Reveal delay={2}>
              <p className="mt-6 text-base leading-relaxed text-brand-graphite/75 max-w-xl">{WHY.body}</p>
            </Reveal>
          </div>
          <Reveal delay={2} className="lg:col-span-6">
            <div className="relative overflow-hidden rounded-sm aspect-[5/4]">
              <img
                src={IMAGES.businessMeeting}
                alt="Team al lavoro in cantina con tablet e dati"
                loading="lazy"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-brand-bordeaux/10" />
            </div>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-brand-bordeaux/10 border border-brand-bordeaux/10 rounded-sm overflow-hidden">
          {WHY.columns.map((c, i) => (
            <Reveal key={c.title} delay={i}>
              <div className="bg-brand-cream p-8 lg:p-10 h-full" data-testid={`why-col-${i}`}>
                <span className="font-mono text-xs text-brand-gold">0{i + 1}</span>
                <h3 className="mt-4 font-serif text-2xl text-brand-bordeaux">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-graphite/70">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
